export enum BIEvents {
  toastViewed = 85,
  updateLogo = 172,
  setupTeamLoad = 250,
  openEditTeamDetailsDialog = 1400,
  teammatesPageLoad = 1401,
  teammatesFilteredByStatus = 1402,
  teammatesFilteredByRole = 1403,
  changeTeammateRoleClicked = 1405,
  updateTeammateRole = 1406,
  openDeleteTeamMemberDialog = 1407,
  deleteTeamMemberClicked = 1408,
  invitePeopleClick = 1409,
  invitePeopleLoad = 1410,
  sendInviteClick = 1411,
  resendInviteClicked = 1412,
  getInviteLink = 1413,
  manageRolesClick = 1414,
  manageRolesLoad = 1415,
  viewRoleClick = 1416,
  viewOrEditRoleLoad = 1417,
  duplicateAndEditClick = 1418,
  editCustomRole = 1419,
  updateCustomRole = 1420,
  createCustomRoleClick = 1421,
  saveCustomRole = 1422,
  deleteCustomRoleClicked = 1423,
  deleteCustomRoleSuccess = 1424,
  cannotDeleteCustomRole = 1425,
  teamManagementLearnMoreClicked = 1426,
  openEditTeamProfileDialog = 1427,
  saveTeamDetails = 1428,
  upgradeButtonClick = 1432,
  inviteEmailsError = 1433,
  upgradeModalLoad = 1434,
}

export const BISources = {
  myAccount: 5,
};

export enum logoActionTypes {
  replace = 'replace',
  remove = 'remove',
  add = 'add',
  upload = 'upload',
  purchase = 'purchase'
}
